import { render, staticRenderFns } from "./mechinDetail.vue?vue&type=template&id=264f2cfe&scoped=true&"
import script from "./mechinDetail.vue?vue&type=script&lang=ts&"
export * from "./mechinDetail.vue?vue&type=script&lang=ts&"
import style0 from "./mechinDetail.vue?vue&type=style&index=0&id=264f2cfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f2cfe",
  null
  
)

export default component.exports